import { SamplesBudgetApiClient } from '@fourthwall/services/dist/SamplesBudgetApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useReferralConfigurationQuery = createQueryHook(
  SamplesBudgetApiClient.getReferralConfiguration,
  {
    queryKey: ['referralConfiguration'],
  },
)
